<dt-modal-content (closeClick)="dialogRef.close()" [contentPadding]="false" [flexContent]="true">
  <ng-template #title i18n>Excel-Anbindung</ng-template>

  <ng-template #content>
    <mat-tab-group [(selectedIndex)]="tabIdx" mat-stretch-tabs color="accent" mat-align-tabs="center">
      <mat-tab labelClass="excel-tab-label">
        <ng-template mat-tab-label i18n>Export</ng-template>
        <div class="export-container">
          <div i18n
            >Hier kannst Du Dein Wirkungsmodell als Excel-Datei exportieren und später in derselben Struktur über das entsprechende Tab
            wieder importieren. Bitte beachte hierbei folgende Punkte:</div
          >
          <ul class="bullets">
            <li i18n>Ziele und Skalen darfst Du nicht verändern.</li>
            <li i18n>Verändern kannst Du hingegen alle Wirkungsprognosen (weiß), sofern Du Werte innerhalb der Skala wählst.</li>
            <li i18n
              >Einflussfaktoren kannst Du in Matrixfeldern entfernen oder auch neu hinzufügen, soweit sie in Deinem Projekt definiert
              sind.</li
            >
            <li i18n
              >Wahrscheinlichkeiten aller benutzerdefinierter Einflussfaktoren kannst Du anpassen, die Summe der Zustände muss jedoch immer
              bei 100&nbsp;% liegen.</li
            >
            <li i18n>Neue Alternativen kannst Du hinzufügen, indem Du diese in neuen Zeilen an die bestehende Matrix anfügst.</li>
          </ul>
          <div class="small-text" i18n>Weitere Hinweise findest Du im Tab README in der Excel-Datei.</div>
          <mat-checkbox class="protection-checkbox" [(ngModel)]="unProtectSheet" i18n
            >Einschränkungen der Excel-Datei aufheben (Expertenmodus)</mat-checkbox
          >
          @if (includesDuplicateAlternatives) {
            <mat-error class="dt-error" i18n>Dein Wirkungsmodell enthält eine oder mehrere Alternativen mit demselben Namen.</mat-error>
          }
        </div>
      </mat-tab>
      <mat-tab labelClass="excel-tab-label" [disabled]="readonly">
        <ng-template mat-tab-label i18n>Import</ng-template>
        <div class="import-container">
          <div i18n>Hier kannst Du Dein Wirkungsmodell aus Deiner Excel-Datei importieren.</div>
          <div
            class="drag-area"
            [class.dragging]="showDragArea"
            (dragenter)="dragEnter()"
            (dragleave)="dragLeave()"
            (drop)="drop($event)"
            (dragover)="dragOver($event)"
            (click)="excelFileInput.click()"
          >
            @if (showDragArea) {
              <span i18n>Legen Sie eine Excel-Datei hier ab, um sie zu laden</span>
            }
            @if (!showDragArea && file == null) {
              <span i18n>Excel-Datei hochladen</span>
            }
            @if (!showDragArea && file != null) {
              <span i18n>Eine andere Excel-Datei laden</span>
            }
            <input
              #excelFileInput
              style="display: none"
              type="file"
              accept=".xlsx"
              (change)="uploadFromInput(excelFileInput)"
              data-cy="project_file_input"
            />
          </div>
          <div class="uploaded-file">
            <mat-icon>description</mat-icon>
            @if (file != null) {
              <span class="file-name">{{ file.name }}</span>
            }
            @if (file == null) {
              <span class="file-name" i18n>Noch keine Datei geladen</span>
            }
          </div>
          @if (file != null) {
            <div class="log-container">
              @if (excelForecastExportService.loadingImportSuccessful) {
                @if (excelForecastExportService.hasEmptyCells) {
                  <div class="info-message">
                    <mat-icon
                      [matTooltip]="'Es werden nur die ausgefüllten Felder importiert. Leere Felder behalten ihre vorherigen Werte bei.'"
                      i18n-matTooltip
                      [matTooltipPosition]="'below'"
                      >info</mat-icon
                    >
                    <div>
                      <div class="info-title" i18n>Leere Felder entdeckt</div>
                    </div>
                  </div>
                }
                @if (excelForecastExportService.hasVerbalizedIndicatorScales) {
                  <div class="info-message">
                    <mat-icon
                      [matTooltip]="
                        'Es wurden verbalisierte Indikatorskalen in der Excel-Datei entdeckt. Die Werte der Skalen werden nicht importiert.'
                      "
                      i18n-matTooltip
                      [matTooltipPosition]="'below'"
                      >info</mat-icon
                    >
                    <div>
                      <div class="info-title" i18n>Verbalisierte Indikatorskalen entdeckt</div>
                    </div>
                  </div>
                }
                @for (changeMessage of changeMessages | keyvalue; track changeMessage) {
                  @if (changeMessage.value.messages.length > 0) {
                    <div class="message-title">
                      {{ changeMessage.value.title }}
                    </div>
                  }
                  <ul class="message-list-container">
                    @for (changeMessageRow of changeMessage.value.messages; track changeMessageRow) {
                      <li class="message-list-entry">
                        {{ changeMessageRow }}
                      </li>
                    }
                  </ul>
                }
              }
              @if (excelForecastExportService.loadingImportSuccessful === false) {
                <div class="status status-red" i18n>Die Datei kann nicht importiert werden.</div>
                @for (errorMessage of errorMessages | keyvalue; track errorMessage) {
                  @if (errorMessage.value.messages.length > 0) {
                    <div class="message-title">
                      {{ errorMessage.value.title }}
                    </div>
                  }
                  <ul class="message-list-container">
                    @for (errorMessageRow of errorMessage.value.messages; track errorMessageRow) {
                      <li class="message-list-entry">
                        {{ errorMessageRow }}
                      </li>
                    }
                  </ul>
                }
              }
            </div>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-template>

  <ng-template #footer>
    @if (tabIdx === 0) {
      <button mat-raised-button color="accent" (click)="export()" i18n data-cy="export-button">Exportieren</button>
    }
    @if (tabIdx === 1) {
      <button mat-raised-button color="accent" [disabled]="!excelForecastExportService.loadingImportSuccessful" (click)="import()" i18n
        >Importieren</button
      >
    }
    <button mat-raised-button color="accent" (click)="dialogRef.close()" i18n>Abbrechen</button>
  </ng-template>
</dt-modal-content>
